import { useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const DEFAULTS = {
  hero_title: "Politics is a conversation.",
  hero_subtitle: "This is where it happens.",
  hero_copy:
    "A moderated forum for essays, polls, and public debate on what we expect from politics — and the politicians who claim to serve us. Every contribution is read by an editor before it appears here. Read on.",
  hero_align: "left",
  footer_copy:
    "A digital journalism project that seeks to generate conversation and comment around what people want and expect from politics and politicians.",
  about_body: "",
  ticker_label: "Editor's Choice",
  ticker_items: [
    { text: "What do we want?", url: "/submit" },
    { text: "When do we want it?", url: "/polls" },
    { text: "Ideas over ideology.", url: "/debates" },
    { text: "The people, the polls, the plans.", url: "/polls" },
    { text: "Conversations about politics and media.", url: "/register" },
  ],
  background_url: "",
  background_mode: "tile",
  hero_bg_left_url: "",
  hero_bg_left_align: "center",
  hero_bg_right_url: "",
  hero_bg_right_align: "center",
};

export function useSettings() {
  const [settings, setSettings] = useState(DEFAULTS);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/settings");
      setSettings({ ...DEFAULTS, ...data });
    } catch (err) {
      console.warn("Failed to load site settings, using defaults:", err);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return { settings, reload: load };
}

export const SETTINGS_DEFAULTS = DEFAULTS;
